import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Card from '../../card/card';
import cloneDeep from 'lodash/cloneDeep';
import FCSlider from '../../fc_slider/fc_slider';
import Ad from '../../ad/ad';
import generateTagData from '../../../../utils/advertorial_utils';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import log from '../../../../services/logger_service';

import Cookies from 'js-cookie';
import MobileVideoPlayer from '../../mobile_video_module/mobile_video_module_reactjw';
import Sticky from 'react-stickynode';

import { trackGAEvent } from '../../../../client/utils/third_party_trackers/ga';

class Article extends Component {
  constructor() {
    super();
    this.state = {
      midArticleInjection: null,
      midArticleInjectLoaded: false,
      alwaysOn: null,
      alwaysOnLoaded: false,
      hideMobileVideoPlayer: false,
      globalPlayerLoaded: false,
      showGlobalPlayer: null
    };

    this.renderNativeAlwaysOn = this.renderNativeAlwaysOn.bind(this);
    this.hideMobileVideoPlayer = this.hideMobileVideoPlayer.bind(this);

    this.isMobile = false;
    this.showPlayer = false; // Remove once debugged.
  }

  componentDidMount() {
    this.checkWindowSize();
    window.addEventListener('resize', this.checkWindowSize.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (isAdvertorial(get(nextProps, 'post.tags'))) {
      return;
    }

    if (
      !this.state.midArticleInjection &&
      get(nextProps, 'postNativeAd.length')
    ) {
      const modifiedInjectionArticle = get(nextProps, 'postNativeAd[0]');
      const advertiserData = generateTagData(
        get(modifiedInjectionArticle, 'tags')
      );

      modifiedInjectionArticle.customEyebrowText = get(
        advertiserData,
        'advertiser'
      );

      this.setState({
        midArticleInjection: [modifiedInjectionArticle]
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!this.state.alwaysOnLoaded && this.state.alwaysOn) {
      // console.log('setting always on Loaded');
      this.setState({ alwaysOnLoaded: true });
      return true;
    }

    if (
      !this.state.midArticleInjectLoaded &&
      get(nextProps, 'postNativeAd', []).length
    ) {
      this.setState({ midArticleInjectLoaded: true });
      return true;
    }

    if (!this.state.globalPlayerLoaded && nextState.showGlobalPlayer !== null) {
      // console.log('setting always on Loaded');
      this.setState({ globalPlayerLoaded: true });
      return true;
    }

    return false;
  }

  setPostChunk(chunk, index, totalChunkLength, id) {
    const { post } = this.props;
    const chunks = get(post, 'content', []);
    // console.log('CHUNKS', chunks)

    const { combinedAdModel } = this.props;
    // console.log('Chunk', index, chunk[index])
    const midArticleInjection =
      this.state.midArticleInjection &&
      index === Math.floor(totalChunkLength / 2)
        ? this.state.midArticleInjection.map(article => (
            <div
              className="native-injection"
              key={`native-injection-${article.id}`}
            >
              <Card
                config={this.props.config}
                type="injection"
                metadata={article}
                key={article.id}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: 'nativeMidArticleInjection',
                    eventLabel: get(article, 'title')
                  });
                }}
              />
            </div>
          ))
        : '';

    const alwaysOnInjection =
      this.state.alwaysOn && index === Math.floor(totalChunkLength / 2)
        ? this.state.alwaysOn
        : '';
    // console.log('alwaysOninjection', alwaysOnInjection);
    let midPosition = Math.ceil(chunk.length / 2);
    const preventWithOtherInjections = false;

    // Handles if the chunk contains a header, we dont want to insert it right after the header
    if (
      chunk[midPosition - 1] &&
      (chunk[midPosition - 1].includes('<h2>') ||
        chunk[midPosition - 1].includes('<h3>'))
    ) {
      midPosition = Math.floor(chunk.length / 2 + 1);
    }

    if (
      // this.showPlayer === true && // Un-comment this line disable entirely!
      this.props.pageNum === 0 &&
      index === 0 &&
      this.isMobile &&
      !Cookies.get('fc_rev_content') &&
      !Cookies.get('hideMobileVideoPlayer') &&
      !this.state.hideMobileVideoPlayer
      // !this.state.globalPlayerLoaded
    ) {
      const markupFirstHalf = [...chunk.slice(0, 1)].join('');
      const markupSecondHalf = [...chunk.slice(1, chunk.length)].join('');

      if (
        chunks.join('').indexOf('video-wrapper') !== -1 &&
        preventWithOtherInjections
      ) {
        return (
          // RETURN WITHOUT MOBILE VIDEO INSERT IF THERE IS A VIDEO IN THE ARTICLE
          <Fragment key={`chunk-${index}`}>
            <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
            {this.state.showGlobalPlayer !== null && (
              <div>{this.state.showGlobalPlayer}</div>
            )}
            <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
          </Fragment>
        );
      }

      return (
        // return WITH mobile video insert because there is no video in the article...
        // we just dont want a video ad to appear if there is a video in the article already
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {this.state.showGlobalPlayer !== null && (
            <div>{this.state.showGlobalPlayer}</div>
          )}
          <div
            style={{
              position: 'absolute',
              height: '0',
              width: '0'
            }}
          >
            <Ad
              {...combinedAdModel}
              noBorder={true}
              slug={false}
              name="mobile_video_insertion_test"
              onSlotRenderEnded={event => {
                let renderPlayer = null;
                if (
                  !get(event, 'isEmpty', true) &&
                  get(event, 'creativeId', -2) !== -2 &&
                  window.top.fc_ads !== undefined &&
                  window.top.fc_ads.mobile_jw_insert !== undefined &&
                  window.top.fc_ads.mobile_jw_insert !== null &&
                  window.top.fc_ads.mobile_jw_insert !== ' '
                ) {
                  console.log('✅GOOD LETS RENDER THE PLAYER', '\n', window.top.fc_ads, event); // eslint-disable-line
                  renderPlayer = (
                    <Sticky innerZ="10000000">
                      <MobileVideoPlayer
                        mobileInline={true}
                        type="rightrail"
                        playerid="delVxmba"
                        playlistId={
                          window.top.fc_ads.mobile_jw_insert[0].playlist_id
                        }
                        pos="newmultiplayer"
                        hideMobileVideoPlayer={this.hideMobileVideoPlayer}
                      />
                    </Sticky>
                  );
                } else {
                  console.log('🚨We did NOT get the mobile insert :(', '\n', window.top.fc_ads, event); // eslint-disable-line
                }
                this.setState({
                  showGlobalPlayer: renderPlayer
                });
              }}
            />
          </div>
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    const markupFirstHalf = [...chunk.slice(0, midPosition)].join('');
    const markupSecondHalf = [...chunk.slice(midPosition, chunk.length)].join(
      ''
    );

    if (
      markupFirstHalf === 'INLINE_CAROUSEL' ||
      markupFirstHalf === 'INLINE_CAROUSEL'
    ) {
      return (
        <FCSlider
          key={`inline-slideshow-${id}-${index}`}
          slideShowData={this.inlineCarousels.shift()}
          location="post__inline"
        />
      );
    }

    // just return whole chunk if there's no article injection
    if (midArticleInjection === '' && this.state.alwaysOn == null) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
        </Fragment>
      );
    }

    if (midArticleInjection && alwaysOnInjection) {
      const choice = Math.floor(Math.random() * 2);
      const nativeArray = [midArticleInjection, alwaysOnInjection];

      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {nativeArray[choice]}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (midArticleInjection) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {midArticleInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (alwaysOnInjection) {
      // console.log('✅✅✅✅✅✅✅✅✅✅✅✅');
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {alwaysOnInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    return (
      <Fragment key={`chunk-${index}`}>
        <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
      </Fragment>
    );
  }

  setMobileAdName(index) {
    let adName;
    const adMap = { 0: 'mobileparallax_1', 3: 'mobileparallax_2' };

    if (Object.prototype.hasOwnProperty.call(adMap, index)) {
      adName = adMap[index];
    } else {
      adName = `mobilerectangle_${this.mobileAdIndex}`;
      this.mobileAdIndex += 1;
    }

    return adName;
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth < 1024;
    // console.log('article.js: Is Mobile?', this.isMobile)
    this.forceUpdate();
  }

  hideMobileVideoPlayer() {
    /* eslint-disable-next-line func-names */
    this.setState({ hideMobileVideoPlayer: true }, function() {
      Cookies.set('hideMobileVideoPlayer', true, { expires: 1 });
      this.forceUpdate();
    });
  }

  notAroundCarousel(chunks, currentChunk, index) {
    const next = chunks[index + 1] || [];
    const nextZeroIndex = next[0];
    const carousel = 'INLINE_CAROUSEL';

    if (nextZeroIndex === carousel || currentChunk === carousel) {
      return false;
    }

    return true;
  }

  renderNativeAlwaysOn(response, index) {
    const alwaysOn = (
      <a href={response.clickthrough_url} target="_blank">
        <div
          style={{
            backgroundImage: `url(${response.bg_image})`,
            height: '180px',
            width: '100%',
            backgroundSize: 'contain',
            margin: '20px auto',
            textAlign: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          className={`alwaysOn_${index}`}
        />
      </a>
    );
    this.setState({ alwaysOn }, () => {
      // console.log('this.state.alwaysOn', this.state.alwaysOn);
    });
  }

  render() {
    const {
      config,
      post,
      pageNum,
      combinedAdModel,
      isShortPost,
      advertorial
    } = this.props;

    const chunks = get(post, 'content', []);
    // console.log('CHUNKS', chunks.join(''));

    if (!chunks.length) {
      log.error(
        'No article chunk found, this article has no body content: ',
        get(post, 'link')
      );
    }

    this.mobileAdIndex = 1;
    this.inlineCarousels = cloneDeep(get(post, 'inlineCarousels')) || [];
    const nativePixelContentArticlePageFeatureFlag = get(
      config,
      'featureFlags.nativePixelContentArticlePage'
    );

    const nativeAdPixel = nativePixelContentArticlePageFeatureFlag ? (
      <div>
        <Ad
          {...combinedAdModel}
          pos="btf"
          noBorder={true}
          slug={false}
          name="native_recommendationlink"
          broadcastAdsLoaded={true}
        />

        <Ad
          {...combinedAdModel}
          pos="btf"
          noBorder={true}
          slug={false}
          name="native_sponsoredtile"
        />
        <Ad
          {...combinedAdModel}
          pos="btf"
          noBorder={true}
          slug={false}
          name="native_infinitescroll"
        />
      </div>
    ) : (
      ''
    );

    if (post.isVideoPermalink) {
      return (
        <article className="post__article">
          <p>{post.excerpt}</p>
        </article>
      );
    }

    if (advertorial) {
      for (let i = 0; i < chunks.length; i += 1) {
        for (let j = 0; j < chunks[i].length; j += 1) {
          const regex = /<a[^>]*/gm;
          let matches;

          // eslint-disable-next-line
          while ((matches = regex.exec(chunks[i][j])) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (matches.index === regex.lastIndex) {
              regex.lastIndex += 1;
            }
            // eslint-disable-next-line no-loop-func
            matches.forEach(match => {
              chunks[i][j] = chunks[i][j].replace(
                match,
                `${match} rel="nofollow"`
              );
            });
          }
        }
      }
    }

    return (
      <article
        className={`post__article ${
          advertorial ? 'post__article--advertorial' : ''
        }`}
      >
        {chunks.map((chunk, index) => [
          this.setPostChunk(chunk, index, chunks.length, post.id),
          !isShortPost &&
          index < chunks.length - 1 &&
          this.isMobile === false &&
          this.notAroundCarousel(chunks, chunk[0], index) ? (
            <Ad
              key={`chunk-ad-${index}`}
              {...combinedAdModel}
              pos="btf"
              pageNum={pageNum}
              name={this.setMobileAdName(index)}
            />
          ) : null,
          nativePixelContentArticlePageFeatureFlag &&
          get(post, 'totalParagraphs') >= 7 &&
          !advertorial &&
          index === 0 &&
          this.isMobile === false ? (
            <Ad
              key={`native-ad-${index}`}
              {...combinedAdModel}
              pos="btf"
              noBorder={true}
              slug={false}
              name="native_mid_article_inject"
              callback={response => {
                // console.log('display', response);
                if (response.native_type === 'AlwaysOn') {
                  this.renderNativeAlwaysOn(response, index);
                }
              }}
            />
          ) : null
        ])}
        {nativeAdPixel}
      </article>
    );
  }
}

Article.propTypes = {
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  isShortPost: PropTypes.bool.isRequired
};

function mapStateToProps(state = {}) {
  const nativeAdInjectData = get(
    state,
    'postNativeAd.data.midArticleInject.posts'
  );

  if (nativeAdInjectData) {
    return {
      postNativeAd: nativeAdInjectData
    };
  }

  return {
    postNativeAd: []
  };
}

export default connect(mapStateToProps)(Article);
